// extracted by mini-css-extract-plugin
export default {"about":"About_about__lcHED","about__block":"About_about__block__LsnAp"};